export default __webpack_public_path__ + "static/media/bagde-hero.af9f7c84.png";